import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid';

export const Container = styled(Grid)`
    .MuiFormControl-root {
        width: 100%;
    }
`;